import CartOrderSummary from "./CartOrderSummary";
import compose from "recompose/compose";
import withProps from "recompose/withProps";
import withHandlers from "recompose/withHandlers";
import withCountry from "../../../hocs/withCountry";
import withErrorTranslations from "../../../hocs/withErrorTranslations";
import { getCookies } from "../../../../facades/eagle/helpers/cookies";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  deletePromoCodeThenUpdatePayments,
  deletePromoCode,
} from "src/client/js/store/thunks/cart";
import { replaceTextWithValues } from "src/common/utils/text-replace";

const enhance = compose(
  withErrorTranslations,
  withCountry,
  withRouter,
  connect(null, (dispatch) => ({
    deletePromoCode: (props) => {
      props.location.pathname.includes("/checkout-v2/payment")
        ? dispatch(
            deletePromoCodeThenUpdatePayments(
              getCookies(),
              props.countryModel,
              props.errorMessage
            )
          )
        : dispatch(deletePromoCode());
    },
  })),
  withProps((props) => {
    const values = { quantity: props.itemCount };
    return {
      label: {
        ...props.label,
        itemTotal: replaceTextWithValues(props.label.itemTotal, values),
        discountedTotal: replaceTextWithValues(
          props.label.discountedTotal,
          values
        ),
      },
    };
  }),
  withHandlers({
    onRemoveCode: (props) => () => props.deletePromoCode(props),
  })
);

export default enhance(CartOrderSummary);
